import React, { Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery"
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import styles from "../../../../assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import API from "../../../../_helpers/endpointService";
import axios from "axios";
import { CssTextFieldRow } from "../../../custom/textField";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

// ********* type id's *********
const scope1 = 403;
const scope2 = 404;
const scope3 = 405;
const ghgreduction = 407;

class ListViewCFP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMobile: false,
            ProjectId: 0,
            hide: [],
            UserRole: '',
            MOM_ListView: [],
            Delete: [],
            HoverId: 0,
            index: 0,
            isDisabled: false,
            ghgData: [],
            scope1Data: [],
            scope2Data: [],
            scope3Data: [],
            existId: [],
            pageCount: 1,
            PageNumber: 1,
            PageNo: 1,
            grandTotal: 0,
            existId: [],
            consumedLitresValue: "",
            backupId: [],
            scope1MasterData: [],
            scope2MasterData: [],
            scope3MasterData: [],
            ghgMasterData: [],
            pageCount1: 1,
            pageCount2: 1,
            pageCount3: 1,
            pageCount4: 1,
            pageNumber1: 1,
            pageNumber2: 1,
            pageNumber3: 1,
            pageNumber4: 1,
            isListView: true,
            isDataTable: true,
            grandTotalScope1: 0,
            grandTotalScope2: 0,
            grandTotalScope3: 0,
            grandTotalGhg: 0,
            ghgReductionPercentage: 0

        }
    }


    componentDidMount() {
        const { dispatch } = this.props;
        this.props.dispatch({ type: "SHOW_LOADER", data: true })
        this.state.UserRole = localStorage.getItem("UserRoles");
        this.state.ProjectId = localStorage.getItem("DashId");
        this.setState({})
        this.listViewTable(scope1, 1);
        window.addEventListener("resize", this.resize.bind(this));
        this.resize()
        this.interval = setInterval(() => {
            this.resize1()
        }, 10);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
        window.removeEventListener("resize", this.resize.bind(this));
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Carbonfootprint1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Carbonfootprint").addClass("d-none");
        $("#Carbonfootprint").removeClass("d-block");
        $("#MOML").removeClass("active-color");
        $("#MOMT").removeClass("fw-bolder");
    }

    resize = () => {
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };

    resize1 = () => {
        $("#MAT1 .MuiListItemText-primary").addClass("spanTopBar");
        $("#Carbonfootprint1 .MuiListItemText-primary").addClass("fw-bolder");
        $("#Carbonfootprint").removeClass("d-none");
        $("#Carbonfootprint").addClass("d-block");
        $("#MOML").addClass("active-color");
        $("#MOMT").addClass("fw-bolder");
    }

    listViewTable = (typeId, pageNumber) => {
        let apiUrl = API.CFP_MASTERDATA_BY_ID + `?typeId=${typeId}&projectId=${this.state.ProjectId}&PageNumber=${pageNumber}&PageSize=25`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    switch (typeId) {

                        case scope1:
                            this.state.isListView && this.state.isListView && this.listViewTable(scope2, 1);
                            this.setState({ scope1MasterData: response.data.carbonEmissionMasters, pageCount1: response.data.pagination.PageCount });
                            break;

                        case scope2:
                            this.state.isListView && this.listViewTable(scope3, 1);
                            this.setState({ scope2MasterData: response.data.carbonEmissionMasters, pageCount2: response.data.pagination.PageCount });
                            break;

                        case scope3:
                            this.state.isListView && this.listViewTable(ghgreduction, 1);
                            this.setState({ scope3MasterData: response.data.carbonEmissionMasters, pageCount3: response.data.pagination.PageCount });
                            break;

                        default:
                            this.setState({ ghgMasterData: response.data.carbonEmissionMasters, pageCount4: response.data.pagination.PageCount, isListView: false }, () => { this.dataTable(this.state.ProjectId, scope1, 1) });
                            break;
                    }
                    
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    dataTable = (projectId, typeId) => {
        let apiUrl = API.CFP_MASTERDATA_DAILY_TASK + `?ProjectId=${projectId}&TypeId=${typeId}`;
        axios({
            method: "GET",
            url: apiUrl,
        })
            .then((response) => {
                if (response?.status === 200) {
                    response.data.map((item, index) => {
                        this.state.existId = [...this.state.existId, item.MasterDataId]
                        this.state.backupId = [...this.state.backupId, item.MasterDataId]
                        this.setState({});
                    })
                    switch (typeId) {

                        case scope1:
                            this.state.isDataTable && this.dataTable(this.state.ProjectId, scope2);
                            this.setState({ scope1Data: response.data });
                            response.data.map((emission) => {
                                this.state.grandTotalScope1 = this.state.grandTotalScope1 + (emission.ConsumedFactor * emission.EmissionFactor);
                                this.setState({})
                            })
                            //   this.state.pageCount = Math.round(response.data.Result.length / 25)
                            break;

                        case scope2:
                            this.state.isDataTable && this.dataTable(this.state.ProjectId, scope3);
                            this.setState({ scope2Data: response.data });
                            response.data.map((emission) => {
                                this.state.grandTotalScope2 = this.state.grandTotalScope2 + (emission.ConsumedFactor * emission.EmissionFactor);
                                this.setState({})
                            })
                            break;

                        case scope3:
                            this.state.isDataTable && this.dataTable(this.state.ProjectId, ghgreduction);
                            this.setState({ scope3Data: response.data });
                            response.data.map((emission) => {
                                this.state.grandTotalScope3 = this.state.grandTotalScope3 + (emission.ConsumedFactor * emission.EmissionFactor);
                                this.setState({})
                            })
                            break;

                        default:
                            this.setState({ ghgData: response.data, isDataTable: false });
                            response.data.map((emission) => {
                                this.state.grandTotalGhg = this.state.grandTotalGhg + (emission.ConsumedFactor * emission.EmissionFactor);
                            })
                            this.setState({}, () => this.ghgGrandTotalEmission())
                            break;
                    }
                    if (this.state.paging == true) {
                        // setTimeout(
                            // document.getElementById("additionalTrainings").scrollIntoView(),
                            // window.scrollTo(0, 0)
                            // , 0)
                        this.setState({
                            paging: false
                        })
                    }
                } else {
                    this.props.dispatch({ type: "SHOW_LOADER", data: false })
                }
            })
            .catch((error) => {
                this.props.dispatch({ type: "SHOW_LOADER", data: false })
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    sidebar = () => {
        this.props.navigate("/sidebar");
    }

    postDataBlur = (ID, value, ListViewData) => {
        let scopeData = ListViewData;
        if (value?.trim().length != 0) {
            let data = scopeData.filter((item) => item.MasterDataId == ID)
            let apiUrl = API.CFP_MASTERDATA_DAILY_TASK;
            axios({
                method: "POST",
                url: apiUrl,
                data: data[0],
            })
                .then((response) => {
                    if (response?.status === 200) {
                        this.setState({
                            backupId: [...this.state.backupId, ID]
                        })
                    } else {
                    }
                })
                .catch((error) => {
                    if (error?.response?.status === 401) {
                        // logOut();
                    }
                });
        }

        // this.setState({
        //     existId : [str.Id]
        // })
    }

    handleCheckboxChange = (e, ID, EF, typeId, ListViewData, Name, grandTotalName) => {
        let scopeData = ListViewData;
        this.setState({});
        let deleteData;
        let data = {
            ConsumedFactor: null,
            EmissionFactor: EF,
            IsApplicable: true,
            MasterDataId: ID,
            ProjectId: parseInt(this.state.ProjectId),
            TypeId: typeId,
        }
        const index = this.state.existId.filter((item) => item == ID)
        if (index.length > 0) {
            this.state.existId.map((item, index) => {
                item == ID && (this.state.existId.splice(index, 1))
            })
            scopeData.map((i, ind) => {
                i.MasterDataId == ID && scopeData.splice(ind, 1);
                (i.MasterDataId == ID && this.state.backupId.filter((ite) => ite == ID).length > 0) && this.put_data(i, ID, ListViewData, grandTotalName);
            })
            this.setState({ [Name]: scopeData })
        } else {
            this.state.existId.push(ID);
            this.setState({ [Name]: [...scopeData, data] })
        }

        this.setState({
            consumedLitresValue: EF,
            HoverId: ID,
        })
    }

    handleInputAdditionalCFP = (e, id, ListViewData, Name, grandTotalName) => {

        var pattern = /^\d{0,5}(?:\.\d{0,6})?$/

        let data = ListViewData;

        if (pattern.test(e.target.value)) {
            data.map((item, index) => {
                item.MasterDataId == id && (item.ConsumedFactor = e.target.value ? e.target.value : null)
                this.setState({ [Name]: data })
            })
            this.setState({}, () => { this.grandTotalCalculation(ListViewData, grandTotalName) })
        }
    }

    grandTotalCalculation = (ListViewData, grandTotalName) => {
        this.state.grandTotal = 0;
        let grandTotalList = 0;
        let grandTotalData = ListViewData;
        if (grandTotalData?.length > 0){
            grandTotalData.map((emission) => {
                let totalEmission = (emission.ConsumedFactor * emission.EmissionFactor)
                grandTotalList = grandTotalList + totalEmission;
                this.setState({[grandTotalName] :  grandTotalList})
            })
        } else {
            this.setState({[grandTotalName] : 0});
        }
   
         this.setState({}, () => this.ghgGrandTotalEmission())
    }

  ghgGrandTotalEmission = () => {
     this.setState({
      grandTotal : ( this.state.grandTotalScope1 + this.state.grandTotalScope2 + this.state.grandTotalScope3 )
     }, () => this.ghgReductionPercentage()) 
  }

  ghgReductionPercentage = () => {
    if(this.state.grandTotalGhg > 0){
        this.setState({
            ghgReductionPercentage : (((this.state.grandTotalGhg - this.state.grandTotal)/this.state.grandTotalGhg)*100)
        }, () => this.props.dispatch({ type: "SHOW_LOADER", data: false }))
    } else {
        this.setState({
            ghgReductionPercentage : 0
        }, () => this.props.dispatch({ type: "SHOW_LOADER", data: false }))
    }
  }

    put_data = (dataFalse, ID, ListViewData, grandTotalName) => {
        let data = { ...dataFalse, IsApplicable: false }
        let apiUrl = API.CFP_MASTERDATA_DAILY_TASK;
        axios({
            method: "POST",
            url: apiUrl,
            data: data,
        })
            .then((response) => {
                if (response?.status === 200) {
                    this.state.backupId.map((item, index) => {
                        item == ID && this.state.backupId.splice(index, 1)
                    })
                    this.grandTotalCalculation(ListViewData, grandTotalName);
                } else {
                }
            })
            .catch((error) => {
                if (error?.response?.status === 401) {
                    // logOut();
                }
            });
    };

    BackPage = (typeId) => {
        let tableHeight = document.getElementById("Scope1Emission").offsetHeight;
        let tableHeight1 = document.getElementById("Scope2Emission").offsetHeight;
        let tableHeight2 = document.getElementById("Scope3Emission").offsetHeight;
        // let tableHeight3 = document.getElementById("ghgEmission").offsetHeight;

        switch (typeId) {

            case scope1:
                window.scrollTo(0, 0);
                this.state.pageNumber1 = this.state.pageNumber1 - 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber1);
                break;

            case scope2:
                window.scrollTo(0, tableHeight);
                this.state.pageNumber2 = this.state.pageNumber2 - 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber2);
                break;

            case scope3:
                window.scrollTo(0, tableHeight + tableHeight1);
                this.state.pageNumber3 = this.state.pageNumber3 - 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber3);
                break;

            case ghgreduction:
                window.scrollTo(0, tableHeight + tableHeight1 + tableHeight2);
                this.state.pageNumber4 = this.state.pageNumber4 - 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber4);
                break;

        }
    }

    NextPage = (typeId) => {
        let tableHeight = document.getElementById("Scope1Emission").offsetHeight;
        let tableHeight1 = document.getElementById("Scope2Emission").offsetHeight;
        let tableHeight2 = document.getElementById("Scope3Emission").offsetHeight;
        // let tableHeight3 = document.getElementById("ghgEmission").offsetHeight;

        switch (typeId) {

            case scope1:
                window.scrollTo(0, 0);
                this.state.pageNumber1 = this.state.pageNumber1 + 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber1);
                break;

            case scope2:
                //  tableHeight1.scrollTop = tableHeight;
                window.scrollTo(0, tableHeight);
                this.state.pageNumber2 = this.state.pageNumber2 + 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber2);
                break;

            case scope3:
                window.scrollTo(0, tableHeight + tableHeight1);
                this.state.pageNumber3 = this.state.pageNumber3 + 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber3);
                break;

            case ghgreduction:
                window.scrollTo(0, tableHeight + tableHeight1 + tableHeight2);
                this.state.pageNumber4 = this.state.pageNumber4 + 1;
                this.setState({});
                this.listViewTable(typeId, this.state.pageNumber4);
                break;

        }
    }

    render() {
        let { classes, menuToggle } = this.props;
        return (
            <>
                {
                    this.state.isMobile ?
                        <>
                            <div className="row w-100 mt-4">
                                <div className="col-6 mt-auto">
                                    <List className="pt-4 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                                        <ListItem onClick={this.sidebar} >
                                            <ListItemText id={"MAT" + "1"} className='  textNaviIcon' primary="Daily Tasks" />
                                            <NavigateNextIcon id="MAT" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                                            <Divider className='border-bottom' />
                                        </ListItem>
                                    </List>
                                </div>
                                <div className="col-6 pt-3 mt-5">
                                    <h4>Carbon Foot print calculation</h4>
                                </div>
                            </div>
                        </>
                        :
                        <></>
                }
                <div className={this.state.isMobile ? "ml-auto scroll-hide border-top" : "ml-auto scroll-hide"} style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -95 }}>
                    <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
                        <div className="row px-3">

                            <div className="col-10 pt-2">
                                {this.state.isMobile ? <></> : <h6>Carbon Foot print calculation</h6>}
                            </div>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-1" : "col-12 px-3 pt-1"}>
                        <span>Note: The consumed sources must be measured in tons and electricity in MWh to calculate the total emissions in metric tons.</span>
                        </div>
                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
                            <div  id="Scope1Emission" className="table-responsive" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 1 Emissions</span>
                                <div>
                                <table id="dataTable " className="table mt-2">
                                    <thead>
                                        <tr className="">
                                            <th className="border-left" width="1%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission Source</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Consumed Sources (Tons)</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission factor / tCO2e</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Emissions in t/CO2e</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.scope1MasterData && this.state.scope1MasterData?.map((i, v) => (
                                            ((i.Id !== 0) && (i.TypeId == scope1)) &&

                                            <tr>
                                                <td className="spandoc-td align-middle text-center border-left"><input type="checkbox" name="CFPCheckbox" style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id, i.EmissionFactor, scope1, this.state.scope1Data, "scope1Data", "grandTotalScope1")} checked={this.state.existId.filter((ite) => (i.Id == ite)).length > 0} /></td>
                                                <td className="spandoc-td border-right align-middle border-left">{i.Name}</td>
                                                <td className="spandoc-td border-right align-middle">

                                                    <>

                                                        {this.state.scope1Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope1Data.map((item, index) => (
                                                            (i.Id == item.MasterDataId) &&
                                                            <>
                                                            <div className={(this.state.existId.filter((item) => item == i.Id).length > 0) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, item.MasterDataId, this.state.scope1Data, "scope1Data", "grandTotalScope1")}
                                                                    onBlur={(e) => this.postDataBlur(item.MasterDataId, e.target.value, this.state.scope1Data)}
                                                                    value={item.ConsumedFactor ? item.ConsumedFactor : ''}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"}  ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                             {(item.ConsumedFactor?.toString().length > 0 ) ? <></> :
                                                             <span className="pt-5" style={{ color: '#DD0000' }}>Consumed Sources are required</span>}
                                                             </>
                                                        )) : <>
                                                            <div className={this.state.existId.filter((item) => item == i.Id).length > 0 ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    disabled={this.state.existId.filter((item) => item == i.Id).length > 0 ? false : true}
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    style={{ minHeight: "39px", marginTop: "3px" }}
                                                                    value=""
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"} ${classes.inputfieldAlign}`
                                                                    }} />   </div>
                                                        </>
                                                        }

                                                    </>


                                                </td>

                                                {this.state.scope1Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope1Data.map((item, index) => (
                                                    (i.Id == item.MasterDataId) &&
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{item.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{(item.ConsumedFactor * item.EmissionFactor).toFixed(2)}</td>
                                                    </>

                                                )) :
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{i.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{0}</td>
                                                    </>
                                                }
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="table-active">
                                            <td className="border-left">
                                            </td>
                                            <td className="spandoc-td">

                                            </td>
                                            <td className="spandoc-td">
                                            </td>
                                            <td className="spandoc-td text-right">
                                                <span className="spanTopBar" style={{ color: "#000000", padding: "5px" }}>
                                                    Grand total
                                                </span>
                                            </td>
                                            <td className="spandoc-td border-right text-right">
                                                <span className="spanTopBar pl-1" style={{ color: "#000000" }}>{this.state.grandTotalScope1.toFixed(2)}</span>
                                            </td>

                                        </tr>
                                    </tfoot>
                                </table>
                                </div>
                            </div>
                            <div className={`pagination-cfp mb-2`}>
                                <div className={`paginationItem-cfp`}>
                                    {this.state.pageNumber1 == 1 ? <></> :
                                        <ArrowBackIcon className="arrow-cfp cursorPointer" onClick={() => this.BackPage(scope1)} />
                                    }
                                    <span className="pl-2 pr-2">Page {this.state.pageNumber1}</span>
                                    {( this.state.pageCount1 <= 1  || this.state.pageNumber1 == this.state.pageCount1) ? <></> :
                                        <ArrowForwardIcon className="classes.arrow cursorPointer" onClick={() => this.NextPage(scope1)} />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3"}>
                            <div id="Scope2Emission" className="table-responsive" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 2 Emissions</span>
                                <table id="dataTable" className="table mt-2">
                                    <thead>
                                        <tr className="">
                                            <th className="border-left" width="1%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission Source</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Consumed MWh/Tons</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission factor / tCO2e</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Emissions in t/CO2e</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.scope2MasterData && this.state.scope2MasterData?.map((i, v) => (
                                            (i.Id !== 0) &&

                                            <tr>
                                                <td className="spandoc-td align-middle text-center border-left"><input type="checkbox" name="CFPCheckbox" style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id, i.EmissionFactor, scope2, this.state.scope2Data, "scope2Data", "grandTotalScope2")} checked={this.state.existId.filter((ite) => (i.Id == ite)).length > 0} /></td>
                                                <td className="spandoc-td border-right align-middle border-left">{i.Name}</td>
                                                <td className="spandoc-td border-right align-middle">

                                                    <>

                                                        {this.state.scope2Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope2Data.map((item, index) => (
                                                            (i.Id == item.MasterDataId) &&
                                                            <>
                                                            <div className={(this.state.existId.filter((item) => item == i.Id).length > 0) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, item.MasterDataId, this.state.scope2Data, "scope2Data", "grandTotalScope2")}
                                                                    onBlur={(e) => this.postDataBlur(item.MasterDataId, e.target.value, this.state.scope2Data)}
                                                                    value={item.ConsumedFactor ? item.ConsumedFactor : ''}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"}  ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(item.ConsumedFactor?.toString().length > 0 ) ? <></> :
                                                             <span className="pt-5" style={{ color: '#DD0000' }}>Consumed MWh/Tons are required</span>}
                                                             </>
                                                        )) : <>
                                                            <div className={this.state.existId.filter((item) => item == i.Id).length > 0 ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    disabled={this.state.existId.filter((item) => item == i.Id).length > 0 ? false : true}
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    value=""
                                                                    style={{ minHeight: "39px", marginTop: "3px" }}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"} ${classes.inputfieldAlign}`
                                                                    }} />   </div>
                                                        </>
                                                        }

                                                    </>


                                                </td>

                                                {this.state.scope2Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope2Data.map((item, index) => (
                                                    (i.Id == item.MasterDataId) &&
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{item.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{(item.ConsumedFactor * item.EmissionFactor).toFixed(2)}</td>
                                                    </>

                                                )) :
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{i.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{0}</td>
                                                    </>
                                                }
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="table-active">
                                            <td className="border-left">
                                            </td>
                                            <td className="spandoc-td">

                                            </td>
                                            <td className="spandoc-td">
                                            </td>
                                            <td className="spandoc-td text-right">
                                                <span className="spanTopBar" style={{ color: "#000000", padding: "5px" }}>
                                                    Grand total
                                                </span>
                                            </td>
                                            <td className="spandoc-td border-right text-right">
                                                <span className="spanTopBar pl-1" style={{ color: "#000000" }}>{this.state.grandTotalScope2.toFixed(2)}</span>
                                            </td>

                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className={`pagination-cfp mb-2`}>
                                <div className={`paginationItem-cfp`}>
                                    {this.state.pageNumber2 == 1 ? <></> :
                                        <ArrowBackIcon className="arrow-cfp cursorPointer" onClick={() => this.BackPage(scope2)} />
                                    }
                                    <span className="pl-2 pr-2">Page {this.state.pageNumber2}</span>
                                    {( this.state.pageCount2 <= 1  || this.state.pageNumber2 == this.state.pageCount2) ? <></> :
                                        <ArrowForwardIcon className="classes.arrow cursorPointer" onClick={() => this.NextPage(scope2)} />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3"}>
                            <div id="Scope3Emission" className="table-responsive" style={{ width: "100%" }}>
                                <span className="spandoc-thead">Scope 3 Emissions</span>
                                <table id="dataTable " className="table mt-2">
                                    <thead>
                                        <tr className="">
                                            <th className="border-left" width="1%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission Source</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Consumed Sources (Tons)</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission factor / tCO2e</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Emissions in t/CO2e</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.scope3MasterData && this.state.scope3MasterData?.map((i, v) => (
                                            (i.Id !== 0) &&

                                            <tr>
                                                <td className="spandoc-td align-middle text-center border-left"><input type="checkbox" name="CFPCheckbox" style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id, i.EmissionFactor, scope3, this.state.scope3Data, "scope3Data", "grandTotalScope3")} checked={this.state.existId.filter((ite) => (i.Id == ite)).length > 0} /></td>
                                                <td className="spandoc-td border-right align-middle border-left">{i.Name}</td>
                                                <td className="spandoc-td border-right align-middle">

                                                    <>

                                                        {this.state.scope3Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope3Data.map((item, index) => (
                                                            (i.Id == item.MasterDataId) &&
                                                            <>
                                                            <div className={(this.state.existId.filter((item) => item == i.Id).length > 0) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, item.MasterDataId, this.state.scope3Data, "scope3Data", "grandTotalScope3")}
                                                                    onBlur={(e) => this.postDataBlur(item.MasterDataId, e.target.value, this.state.scope3Data)}
                                                                    value={item.ConsumedFactor ? item.ConsumedFactor : ''}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"}  ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(item.ConsumedFactor?.toString().length > 0 ) ? <></> :
                                                             <span className="pt-5" style={{ color: '#DD0000' }}>Consumed Sources are required</span>}
                                                             </>
                                                        )) : <>
                                                            <div className={this.state.existId.filter((item) => item == i.Id).length > 0 ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    disabled={this.state.existId.filter((item) => item == i.Id).length > 0 ? false : true}
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    value=""
                                                                    style={{ minHeight: "39px", marginTop: "3px" }}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"} ${classes.inputfieldAlign}`
                                                                    }} />   </div>
                                                        </>
                                                        }

                                                    </>


                                                </td>

                                                {this.state.scope3Data.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.scope3Data.map((item, index) => (
                                                    (i.Id == item.MasterDataId) &&
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{item.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{(item.ConsumedFactor * item.EmissionFactor).toFixed(2)}</td>
                                                    </>

                                                )) :
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{i.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{0}</td>
                                                    </>
                                                }
                                            </tr>



                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="table-active">
                                            <td className="border-left">
                                            </td>
                                            <td className="spandoc-td">

                                            </td>
                                            <td className="spandoc-td">
                                            </td>
                                            <td className="spandoc-td text-right">
                                                <span className="spanTopBar" style={{ color: "#000000", padding: "5px" }}>
                                                    Grand total
                                                </span>
                                            </td>
                                            <td className="spandoc-td border-right text-right">
                                                <span className="spanTopBar pl-1" style={{ color: "#000000" }}>{this.state.grandTotalScope3.toFixed(2)}</span>
                                            </td>

                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className={`pagination-cfp mb-2`}>
                                <div className={`paginationItem-cfp`}>
                                    {this.state.pageNumber3 == 1 ? <></> :
                                        <ArrowBackIcon className="arrow-cfp cursorPointer" onClick={() => this.BackPage(scope3)} />
                                    }
                                    <span className="pl-2 pr-2">Page {this.state.pageNumber3}</span>
                                    {( this.state.pageCount3 <= 1  || this.state.pageNumber3 == this.state.pageCount3) ? <></> :
                                        <ArrowForwardIcon className="classes.arrow cursorPointer" onClick={() => this.NextPage(scope3)} />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3"}>
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="dataTable" className="table mt-2">
                                    <thead className="">
                                        <tr className="">
                                            <th className=" border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total GHG Emissions During Recycling of Steel and Other Components</span></th>
                                            <th className="border-right text-right" width="2.8%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>{this.state.grandTotal.toFixed(2)}</span></th>
                                        </tr>
                                    </thead>

                                </table>
                            </div>
                        </div>

                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3"}>
                            <div id="ghgEmission" className="table-responsive" style={{ width: "100%" }}>
                                <h6 className="mb-2">GHG Reduction:</h6>
                                <span className="spandoc-thead">Estimated GHG Emissions During New Production of Steel and Other Components</span>
                                <table id="dataTable" className="table mt-2">
                                    <thead>
                                        <tr>
                                            <th className="border-left" width="1%"><span className="spandoc-thead" style={{ color: "#000000" }}></span></th>
                                            <th className="border-right border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission Source</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Consumed Sources (Tons)</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Emission factor / tCO2e</span></th>
                                            <th className="border-right" width="5%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>Total Emissions in t/CO2e</span></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state?.ghgMasterData && this.state.ghgMasterData?.map((i, v) => (
                                            (i.Id !== 0) &&

                                            <tr>
                                                <td className="spandoc-td align-middle text-center border-left"><input type="checkbox" name="CFPCheckbox" style={{ width: "16px", height: '16px' }} onChange={(e) => this.handleCheckboxChange(e, i.Id, i.EmissionFactor, ghgreduction, this.state.ghgData, "ghgData" , "grandTotalGhg")} checked={this.state.existId.filter((ite) => (i.Id == ite)).length > 0} /></td>
                                                <td className="spandoc-td border-right align-middle border-left">{i.Name}</td>
                                                <td className="spandoc-td border-right align-middle">

                                                    <>

                                                        {this.state.ghgData.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.ghgData.map((item, index) => (
                                                            (i.Id == item.MasterDataId) &&
                                                            <>
                                                            <div className={(this.state.existId.filter((item) => item == i.Id).length > 0) ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    type="text"
                                                                    id={"actName" + i.Id}
                                                                    onMouseEnter={(e) => this.setState({ HoverId: i.Id })}
                                                                    style={{ minHeight: "39px", marginTop: "-3px" }}
                                                                    onChange={(e) => this.handleInputAdditionalCFP(e, item.MasterDataId, this.state.ghgData, "ghgData", "grandTotalGhg")}
                                                                    onBlur={(e) => this.postDataBlur(item.MasterDataId, e.target.value, this.state.ghgData)}
                                                                    value={item.ConsumedFactor ? item.ConsumedFactor : ''}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"}  ${classes.inputfieldAlign}`
                                                                    }} />
                                                            </div>
                                                            {(item.ConsumedFactor?.toString().length > 0 ) ? <></> :
                                                             <span className="pt-5" style={{ color: '#DD0000' }}>Consumed Sources are required</span>}
                                                             </>
                                                        )) : <>
                                                            <div className={this.state.existId.filter((item) => item == i.Id).length > 0 ? "border-bg" : "border-bg-none"}>
                                                                <CssTextFieldRow
                                                                    multiline
                                                                    fullWidth
                                                                    variant="outlined"
                                                                    disabled={this.state.existId.filter((item) => item == i.Id).length > 0 ? false : true}
                                                                    type="text"
                                                                    value=""
                                                                    id={"actName" + i.Id}
                                                                    style={{ minHeight: "39px", marginTop: "3px" }}
                                                                    InputProps={{
                                                                        className: `border-radius padding-space-trainings spandoc-tbody ${this.state.existId.filter((item) => item == i.Id).length > 0 ? "" : "color-grey"} ${classes.inputfieldAlign}`
                                                                    }} />   </div>
                                                        </>
                                                        }

                                                    </>


                                                </td>

                                                {this.state.ghgData.filter((ite) => (i.Id == ite.MasterDataId)).length > 0 ? this.state.ghgData.map((item, index) => (
                                                    (i.Id == item.MasterDataId) &&
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{item.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{(item.ConsumedFactor * item.EmissionFactor).toFixed(2)}</td>
                                                    </>

                                                )) :
                                                    <>
                                                        <td className="spandoc-td border-right align-middle text-right">{i.EmissionFactor}</td>
                                                        <td className="spandoc-td border-right align-middle text-right">{0}</td>
                                                    </>
                                                }
                                            </tr>



                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="table-active">
                                            <td className="border-left">
                                            </td>
                                            <td className="spandoc-td">

                                            </td>
                                            <td className="spandoc-td">
                                            </td>
                                            <td className="spandoc-td text-right">
                                                <span className="spanTopBar" style={{ color: "#000000", padding: "5px" }}>
                                                    Grand total
                                                </span>
                                            </td>
                                            <td className="spandoc-td border-right text-right">
                                                <span className="spanTopBar pl-1" style={{ color: "#000000" }}>{this.state.grandTotalGhg.toFixed(2)}</span>
                                            </td>

                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div className={`pagination-cfp mb-2`}>
                                <div className={`paginationItem-cfp`}>
                                    {this.state.pageNumber4 == 1 ? <></> :
                                        <ArrowBackIcon className="arrow-cfp cursorPointer" onClick={() => this.BackPage(ghgreduction)} />
                                    }
                                    <span className="pl-2 pr-2">Page {this.state.pageNumber4}</span>
                                    {( this.state.pageCount4 <= 1  || this.state.pageNumber4 == this.state.pageCount4 ) ? <></> :
                                        <ArrowForwardIcon className="classes.arrow cursorPointer" onClick={() => this.NextPage(ghgreduction)} />
                                    }
                                </div>
                            </div>
                        </div>

                        <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3"}>
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table id="dataTable" className="table mt-2">
                                    <thead className="">
                                        <tr className="">
                                            <th className=" border-left" width="10%" style={{ minWidth: '70px' }}><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>GHG Reduction percentage</span></th>
                                            <th className="border-right text-right" width="2.8%"><span className="spandoc-thead" style={{ color: "#000000", whiteSpace: 'nowrap' }}>{( this.state.ghgReductionPercentage ? this.state.ghgReductionPercentage.toFixed(2) : 0 ) + "%"}</span></th>
                                        </tr>
                                    </thead>

                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
    };
}

ListViewCFP.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ListViewCFP))
);
